import {
  BulkDestroyDocumentsUploadProcessDocumentsDocument,
  BulkDestroyDocumentsUploadProcessDocumentsMutation,
  BulkDestroyDocumentsUploadProcessDocumentsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkDestroyUploadProcessDocuments = () => {
  const [mutate, { loading }] = useMutation(BulkDestroyDocumentsUploadProcessDocumentsDocument, {
    extractorFn: (data: BulkDestroyDocumentsUploadProcessDocumentsMutation) =>
      data.documentsMutations.bulkDestroyDocumentsUploadProcessDocument,
  })

  const bulkDestroyUploadProcessDocuments = (
    variables: BulkDestroyDocumentsUploadProcessDocumentsMutationVariables
  ) => {
    return mutate({
      variables,
    })
  }

  return { bulkDestroyUploadProcessDocuments, loading }
}
